export default __webpack_public_path__ + "static/media/Subtle-Prism.d1187c44.svg";